const light = {
  primary: "#dae0e6",
  secondary: "#ffffff",
  text: "#333333",
};
const dark = {
  primary: "#696969",
  secondary: "#343a40",
  text: "#ffffff",
};
const palette = [
  { name: "light", color: light },
  { name: "dark", color: dark },
];
export default palette;
